/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QualificationKeyValueCodeModel } from '../../models/qualification-key-value-code-model';

export interface MasterDataQualificationLookupByValueGet$Params {
  value?: string;
  maxResults?: number;
  qualificationTypeId?: string;
  languageRegion?: string;
}

export function masterDataQualificationLookupByValueGet(http: HttpClient, rootUrl: string, params?: MasterDataQualificationLookupByValueGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<QualificationKeyValueCodeModel>>> {
  const rb = new RequestBuilder(rootUrl, masterDataQualificationLookupByValueGet.PATH, 'get');
  if (params) {
    rb.query('value', params.value, {});
    rb.query('maxResults', params.maxResults, {});
    rb.query('qualificationTypeId', params.qualificationTypeId, {});
    rb.query('languageRegion', params.languageRegion, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<Array<QualificationKeyValueCodeModel>>;
    })
  );
}

masterDataQualificationLookupByValueGet.PATH = '/MasterData/QualificationLookupByValue';
